// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"675":"extra","945":"dashboard"}[chunkId] + "." + {"675":"b0c857a1","945":"1085e77a"}[chunkId] + ".js";
};